const SET_CONFIG = 'set-config';
const FETCH_CONFIG = 'fetch-config';
const SET_OVERRIDE = 'set-override';

export { SET_CONFIG, FETCH_CONFIG, SET_OVERRIDE };
